module.exports = __webpack_public_path__ + "static/media/trumpet.4f69a767.svg";